import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import './form-group.scss';

const APFormGroup = (props) => {
  const {
    direction = 'horizontal',
    grid = true,
    gridGap = 2,
    verticalGap = 2,
    wrap = false,
    title,
    className,
    children,
    ...restProps
  } = props;

  return (
    <div
      className={clsx('ap-form-group', `ap-form-group-vertical-gap--${verticalGap}`, className)}
      {...restProps}
    >
      {title && (
        <h3 className="ap-form-group__title">
          {title}
        </h3>
      )}
      <div
        className={clsx(
          'ap-form-group__content',
          grid && [
            'ap-form-group__grid',
            `ap-form-group__grid--${direction}`,
            wrap && 'ap-form-group__grid--wrap',
            `ap-grid-gap--${gridGap}`,
          ],
          !grid && 'ap-form-group__section',
        )}
      >
        {children}
      </div>
    </div>
  );
};

APFormGroup.propTypes = {
  direction: PropTypes.oneOf(['horizontal', 'vertical']),
  gridGap: PropTypes.number,
  title: PropTypes.string,
  children: PropTypes.node,
};

export default APFormGroup;
